// FEW
export const fewBranchId = "d630f828-7da5-4ac6-a322-2ddb36d1da1a"
// HUB
export const fortusEwBranchId = process.env.FORTUS_HUB_ID || "5d632b17-1409-446f-81c0-e8c6a4703052"

export const dublCorkBranchId = "d30b9a46-7986-4a7a-a4c1-5453b204180b"
export const norwichBranchId = "52968d32-304c-4a65-b330-c58b1b35c647"
export const birminghamBranchId = "9d9f9bdc-7b5e-4b2a-8aa1-26ea6795ae13"
export const bedfordBranchId = "91a2f8ab-5042-4202-9d93-2424bceb18fe"
export const sspBranchId = "1716a3a7-c62c-4108-991e-bb15f29eed9a"
export const egsBranchId = "b9962a49-2a40-49a3-a46a-84ace7e1febe"
export const teessideBranchId = "019b26d8-c0e5-7d72-fc8a-dca4967d695f"
export const londonBranchId = "9833635c-2509-4eee-ba90-ec6f83281108"

export const INVOICE_CUT_OFF_DATE = "2023-05-01"

// The nominal accounts sent to MRGE when a stock take add is exported. Sage only falls back to the
// nominal codes held against the stock item itself when we do not send these.
export const mrgeStockAccountNominal = "1001"
export const mrgeIssuesAccountNominal = "5154"

export const INDEX_DEBOUNCE_TIME = 1000
export const REPORTS_LOAD_TIME_DELAY = process.env.NODE_ENV === "production" ? 10000 : 0

export const salutations = [
  { id: 0, code: "" },
  { id: 1, code: "Mr." },
  { id: 2, code: "Miss" },
  { id: 3, code: "Mrs." },
  { id: 4, code: "Ms." },
  { id: 5, code: "Prof." },
  { id: 6, code: "Dr." },
  { id: 7, code: "Mstr." },
  { id: 8, code: "Master" },
  { id: 9, code: "Sir" },
  { id: 10, code: "Fr." },
  { id: 11, code: "Capt." },
  { id: 12, code: "Lord" },
  { id: 13, code: "Lady" },
  { id: 14, code: "RtHon." },
  { id: 15, code: "Cllr." },
  { id: 16, code: "Rev." },
  { id: 17, code: "VeryRev." },
  { id: 18, code: "Mx" },
]

export const quoteValidLength = 30
